export const clickSound = [
    {
        src: "/lunapark/rocket/clickSound/Click.mp3",
        id: "puzzleClick",
    },
];
